export const tabsDrawer = [
    { label: "Detalle", path: "detail", number: 0 },
    { label: "Comentarios", path: "comments", number: 0 },
]
